import * as React from 'react';
import BaseButton from "../../button/BaseButton";
import { Text } from "../../text";
import { _getButtonBaseStyle, _getTitleBaseStyle } from "./Tab.styles";
import { TabContext } from "./TabContext";
var Tab = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var disabled = props.disabled,
      title = props.title,
      size = props.size,
      value = props.value,
      isActive = props.isActive,
      children = props.children,
      appearance = props.appearance,
      onChange = props.onChange,
      dataTestId = props['data-test-id'];

  var getTitleBaseStyles = function getTitleBaseStyles() {
    return _getTitleBaseStyle(props);
  };

  return /*#__PURE__*/React.createElement(BaseButton, {
    ref: ref,
    disabled: disabled,
    size: size,
    onClick: function onClick(event) {
      onChange === null || onChange === void 0 ? void 0 : onChange(event, value);
    },
    sx: _getButtonBaseStyle(props),
    "data-test-id": dataTestId
  }, /*#__PURE__*/React.createElement(TabContext.Provider, {
    value: {
      isActive: isActive,
      appearance: appearance
    }
  }, children || /*#__PURE__*/React.createElement(Text, {
    as: "span",
    _getBaseStyle: getTitleBaseStyles
  }, title)));
});
Tab.displayName = 'Tab';
export default Tab;
export { Tab };